<form [formGroup]="branchData" id="branch-selector-form">
  <label for="branchSelector" id="branch-selector-heading" class="h-4 mb-3">My Branches</label>
  <ng-select id="branch-selector" [items]="branches" [bindValue]="'id'" [bindLabel]="'fullBranchName'"
    placeholder="Select a branch" formControlName="selectedBranch">
  </ng-select>
</form>
